<template>
  <div>
    <div
      class=""
      v-if="$store.getters.get_campu == null || $store.getters.get_rol == null"
    >
      <CRow v-if="$store.getters.get_campu == null">
        <CampusVue :campus="cpCam" :logo="logo" @mtdSetCampu="mtdSetCampu" />
      </CRow>
      <CRow v-else>
        <RolVue :roles="roles" @mtdSetRol="mtdSetRol" />
      </CRow>
    </div>
    <div v-else>
      <AdministradorVue v-if="$store.getters.get_rol.id == 1" />
      <RecepcionistVue v-if="$store.getters.get_rol.id == 2" />
      <CocinaVue v-if="$store.getters.get_rol.id == 3" />
      <MozoVue v-if="$store.getters.get_rol.id == 4" />
      <SupervisorVue v-if="$store.getters.get_rol.id == 5" />
    </div>
  </div>
</template>

<script>
import CampusVue from "../components/home/Campus.vue";
import RolVue from "../components/home/Rol.vue";
import AdministradorVue from "../views/administrador/index.vue";
import RecepcionistVue from "./receptionist/index.vue";
import AdministradorHowertVue from "./administradorHowert/index.vue";
import VendedorVue from "./Vendedor/index.vue";
import SupervisorVue from "./Supervisor/index.vue";
import CocinaVue from "./Cocina/index.vue";
import MozoVue from "./Mozo/index.vue";


export default {
  name: "Dashboard",
  components: {
    CampusVue,
    RolVue,
    AdministradorVue,
    AdministradorHowertVue,
    RecepcionistVue,
    VendedorVue,
    SupervisorVue,
    CocinaVue,
    MozoVue,
  },
  data() {
    return {
      roles: [],
      rol: null,
      campus: [],
      logo: null,
    };
  },
  computed: {
    cpCam() {
      return this.$store.getters.get_campus;
    },
  },
  created() {
    this.$store.getters.get_all_user.roles.forEach((element) => {
      this.roles.push(element.role);
    });
    this.logo =
      this.$store.getters.get_all_user.id == 1
        ? null
        : this.$store.getters.get_company.logo;
  },
  methods: {
    mtdSetRol: function (payload) {
      this.$store.commit("mt_set_rol", payload);
    },
    mtdSetCampu: function (payload) {
      this.$store.commit("mt_set_campu", payload);
    },
    mtdSetRol2: function () {
      this.$emit("mtdSetRol", this.$store.getters.get_all_user.roles[0].role);
    },
  },
};
</script>
